<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns" [ngStyle]="{'width': col.width}"
        [pSortableColumn]="col.field==isLab ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field==isLab ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td *ngIf="col.field!=isActive && col.field != isLab" class="wrapword">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == isActive ">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field==isLab">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" class="h-2rem" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" position="top" [(visible)]="displayMasterListDialog"  [focusOnShow]="false"
  showEffect="fade" [modal]="true" [style]="{'width':'800px'}"  >
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2 col-12 flex" style="margin-bottom: -1rem">
        <div class="col-4">
          <label>{{col.header}}</label>
        </div>
        <div class="col-1">
          :
        </div>
        <div class="col-7">
          <div *ngIf="col.field == isLab">
            <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true"  filterBy="label" placeholder="Select a Lab"
              optionLabel="name" [showClear]="true"></p-dropdown>
          </div>
          <div *ngIf="col.field == isCategory">
            <p-dropdown [options]="problemOptions" [(ngModel)]="selectedCategory" filter="true" filterBy="label"
              placeholder="Select a Problem Category" [showClear]="true" optionLabel="categoryName"></p-dropdown>
          </div>
          <div *ngIf="col.field == isDescription">
            <textarea type="text" rows="3" cols="48" class="w-full"
            [(ngModel)]="masterList[col.field]" placeholder="Enter Description here">
             </textarea>
          </div>
          <div *ngIf="col.field == isSeverity">
            <input pInputText type="number" step="1" min="0" max="999" style="width: 5rem;"  [(ngModel)]="masterList[col.field]">
            <span *ngIf="severityCheck()" class="warningMsg"><small class="p-invalid">Range 0-999 </small></span>
          </div>
          <div *ngIf="col.field == isProblem">
            <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
              (change)="masterList[col.field]=masterList[col.field].trim()">
          </div>
          <div *ngIf="col.field == isExtProblemCode || col.field == isStandardCode">
            <input pInputText class="form-control"  style="width: 5rem;" [(ngModel)]="masterList[col.field]"
              (change)="masterList[col.field]=masterList[col.field].trim()">
          </div>



          <div *ngIf="col.field == isActive">
            <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end">
    <button class="saveButton" type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()"
      (click)="saveMasterList()" class="h-2rem" label="Save"></button>
  </div>

</p-dialog>
